import { get , post } from './http.js'
let baseURL='https://admin.37vape.com/index.php/api2/'//(new)
// let baseURL='https://admin.yoozitaly.com/index.php/api2/'(old)
// let baseURL='http://yoozi.txunda.com:81/index.php/api2/'//(测试)
export const getDictionaryAll = params => post(baseURL+'data_list/getCountryList',params)
